"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const errorHandling_1 = require("../../utils/errorHandling");
const actionTypes = require("../../actionTypes/modelspace/customer");
exports.initialState = {
    fetchStatus: 'STANDBY',
    addStatus: 'STANDBY',
    removeStatus: 'STANDBY',
    configuration: {
        customerId: '',
        configurationId: ''
    },
    configurations: [],
    validationError: null
};
const fetchStatusLens = monocle.Lens.fromProp('fetchStatus');
const addStatusLens = monocle.Lens.fromProp('addStatus');
const removeStatusLens = monocle.Lens.fromProp('removeStatus');
const configurationLens = monocle.Lens.fromProp('configuration');
const configurationsLens = monocle.Lens.fromProp('configurations');
const validationErrorLens = monocle.Lens.fromProp('validationError');
const methods = {};
exports.methods = methods;
// Fetch
methods[actionTypes.FETCH_REQUEST] = (state, action) => fetchStatusLens.set('FETCHING')(state);
methods[actionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(fetchStatusLens.set('FETCHED'), configurationsLens.set(action.payload))(state);
methods[actionTypes.FETCH_FAILED] = (state, action) => fetchStatusLens.set('FAILED')(state);
// Add
methods[actionTypes.ADD_REQUEST] = (state, action) => fp.function.compose(validationErrorLens.set(null), addStatusLens.set('FETCHING'))(state);
methods[actionTypes.ADD_SUCCESS] = (state, action) => addStatusLens.set('FETCHED')(state);
methods[actionTypes.ADD_FAILED] = (state, action) => addStatusLens.set('FAILED')(state);
methods[actionTypes.VALIDATION_FAILED] = (state, action) => fp.function.compose(validationErrorLens.set((0, errorHandling_1.mapValidationErrors)(action.payload)), addStatusLens.set('FAILED'))(state);
// Remove
methods[actionTypes.REMOVE_REQUEST] = (state, action) => removeStatusLens.set('FETCHING')(state);
methods[actionTypes.REMOVE_SUCCESS] = (state, action) => removeStatusLens.set('FETCHED')(state);
methods[actionTypes.REMOVE_FAILED] = (state, action) => removeStatusLens.set('FAILED')(state);
// Clear
methods[actionTypes.UPDATE_FIELD] = (state, action) => configurationLens.modify((s) => {
    if (!s) {
        return s;
    }
    const c = Object.assign({}, s);
    c[action.payload.key] =
        action.payload.value;
    return c;
})(state);
methods[actionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=customer.js.map